import { TSlugName } from 'shared/typings';
import { TLabelValue } from 'shared/typings';
import { isRussia } from 'shared/utils';

export const getOptionsFromSlug = <T>(data: TSlugName[], map: T) => {
	return data
		.map(({ slug, name }) => ({
			value: slug,
			label: typeof map === 'function' ? map?.()?.[slug]?.name || map?.()?.[slug] || name : name,
		}))
		.sort((a, b) => a.label?.localeCompare(b.label));
};

export const updateOptionsFromText = <T>(data: TLabelValue[], map: T) => {
	return data
		.map(({ value, label }) => ({
			value,
			label: typeof map === 'function' ? map?.()?.[value]?.name || map?.()?.[value] || label : label,
		}))
		.sort((a, b) => {
			if (isRussia(a.label)) {
				return -1;
			}
			if (isRussia(b.label)) {
				return 1;
			}
			return a.label?.toLowerCase().localeCompare(b.label?.toLowerCase());
		});
};
